module.exports = __webpack_public_path__ + "static/media/HRECOS_PANEL_DO_PIERMONT.f9518c75.png";